import type React from "react";
import styled from "styled-components";
import type {
	IVeritreeCardContainerFields,
	IVeritreeCard,
} from "@types-contentful";
import VeritreeCard from "./VeritreeCard";

const Wrapper = styled.div`
	padding: 0 10% 0 10%;
`;

const Container = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	gap: 24px;
`;

const Header = styled.h2`
	text-align: center;
	margin-bottom: 32px;
`;

const VeritreeCardContainer: React.FC<IVeritreeCardContainerFields> = ({
	header,
	cards,
}) => {
	return (
		<Wrapper>
			{header && <Header>{header}</Header>}
			<Container>
				{cards?.map((card: IVeritreeCard) => (
					<VeritreeCard key={card.sys.id} {...card.fields} />
				))}
			</Container>
		</Wrapper>
	);
};

export default VeritreeCardContainer;
